import { saveWorkout } from '../api/workoutApi';

/**
 * Deep-copy one exercise (with sets) onto the same period of other target plans.
 * Dedupes by plan id so shared weekday plans only receive the exercise once.
 */
export async function copyExerciseToOtherPlans({
  get,
  post,
  exercise,
  periodKey,
  targetPlanIds = [],
  clientId,
  eventTypes,
  workout_group_types,
}) {
  const catalogId = exercise?.exercise_id || exercise?.workout_id;
  if (!catalogId) {
    return { success: false, message: 'Exercise catalog ID is missing.' };
  }
  if (!periodKey) {
    return { success: false, message: 'Workout period is required.' };
  }

  const uniquePlanIds = [
    ...new Set(
      (Array.isArray(targetPlanIds) ? targetPlanIds : [targetPlanIds])
        .map(String)
        .filter(Boolean)
    ),
  ];
  if (uniquePlanIds.length === 0) {
    return { success: false, message: 'Select at least one day.' };
  }

  const activeWorkout = {
    exercise_id: catalogId,
    workout_id: exercise.workout_id || catalogId,
  };
  const workoutDetails = {
    workout_rest_time: exercise.rest_time_after || 0,
    sequence_number: 1,
  };
  const sets = (exercise.sets || []).map((set) => ({
    reps: set.reps ?? set.target_reps ?? 0,
    time_seconds: set.time_seconds ?? set.target_time_seconds ?? 0,
    rest_time_seconds: set.rest_time_seconds ?? set.target_rest_seconds ?? 0,
    target_weight: set.target_weight ?? 0,
    target_weight_unit_id: set.target_weight_unit_id || set.weight_unit_id || null,
    weight_unit_id: set.weight_unit_id || set.target_weight_unit_id || null,
  }));

  const failures = [];
  let copied = 0;

  for (const planId of uniquePlanIds) {
    try {
      const res = await saveWorkout(
        post,
        get,
        'plan',
        activeWorkout,
        workoutDetails,
        sets,
        periodKey,
        eventTypes,
        workout_group_types,
        {},
        0,
        planId,
        clientId
      );
      if (res?.status === 200 || res?.data || res?.createdWorkoutId) {
        copied += 1;
      } else {
        failures.push(planId);
      }
    } catch (err) {
      console.error(`Failed to copy exercise to plan ${planId}:`, err);
      failures.push(planId);
    }
  }

  if (copied === 0) {
    return {
      success: false,
      message: 'Failed to copy exercise to the selected day(s).',
    };
  }

  if (failures.length > 0) {
    return {
      success: true,
      warning: true,
      message: `Copied to ${copied} plan${copied === 1 ? '' : 's'}, but ${failures.length} failed.`,
    };
  }

  return {
    success: true,
    message: `Copied to ${copied} day plan${copied === 1 ? '' : 's'}.`,
  };
}
